import type { ReactNode } from 'react'

/**
 * A confirmação de um ato que não tem volta.
 *
 * **Ela existe para dizer o que se perde, não para perguntar "tem certeza?".** A frase de dentro é
 * quem carrega o número de quadros, a data do último download, o que some junto — é o padrão que a
 * correção do bloco documental já usa no app de campo: a confirmação informa, e quem decide é o
 * auditor.
 *
 * O botão que apaga fica à direita e é o único colorido de vermelho. O foco começa no cancelar:
 * `Enter` distraído não apaga uma visita.
 */
export function Confirmar({
  titulo,
  rotulo,
  ocupado,
  aoConfirmar,
  aoCancelar,
  children,
}: {
  titulo: string
  rotulo: string
  ocupado?: boolean
  aoConfirmar: () => void
  aoCancelar: () => void
  children: ReactNode
}) {
  return (
    <div
      className="fundo"
      role="dialog"
      aria-modal="true"
      aria-label={titulo}
      onKeyDown={(evento) => evento.key === 'Escape' && !ocupado && aoCancelar()}
    >
      <div className="caixa">
        <div className="titulo">{titulo}</div>
        <div className="texto">{children}</div>
        <div className="botoes">
          <button className="btn g" disabled={ocupado} onClick={aoCancelar} autoFocus>
            Cancelar
          </button>
          <button className="btn perigo" disabled={ocupado} onClick={aoConfirmar}>
            {ocupado ? 'apagando…' : rotulo}
          </button>
        </div>
      </div>
    </div>
  )
}
